import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNextLearningAction } from "./useNextLearningAction";
import { recordLearningEvent } from "@/lib/learning-engine/eventLogger";
import type { LearningEventInput } from "@/lib/learning-engine/types";

export function useLearningEngine() {
  const queryClient = useQueryClient();
  const nextAction = useNextLearningAction();

  const eventMutation = useMutation({
    mutationFn: (input: LearningEventInput) => recordLearningEvent(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["heirwise-adaptive-learning-engine"] });
    },
  });

  return {
    nextAction: nextAction.data ?? null,
    isLoading: nextAction.isLoading,
    isError: nextAction.isError,
    error: nextAction.error,
    refetchNextAction: nextAction.refetch,
    recordEvent: eventMutation.mutateAsync,
    isRecordingEvent: eventMutation.isPending,
  };
}